import React, { useRef, useCallback } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import moment from "moment";
import { includes, isArray } from "lodash";
import { isDynamicDateRange } from "@/services/parameters/DateRangeParameter";
import DateRangeInput from "@/components/date-inputs/DateRangeInput";
import DateTimeRangeInput from "@/components/date-inputs/DateTimeRangeInput";
import DynamicButton from "@/components/dynamic-parameters/DynamicButton";
import { useTheme } from "@/components/ThemeProvider";

import "./DynamicParameters.less";

function isValidDateRangeValue(value) {
  return isArray(value) && value.length === 2 && moment.isMoment(value[0]) && moment.isMoment(value[1]);
}

function DynamicDateRangePicker({ type, value, onSelect, className, dynamicButtonOptions, dateRangeOptions, parameter, ...rest }) {
  const { isDarkMode } = useTheme();
  const dateRangeComponentRef = useRef();
  const isDateTimeRange = includes(type, "datetime-range");
  const hasDynamicValue = isDynamicDateRange(value);

  const additionalAttributes = {};

  let DateRangeComponent = DateRangeInput;
  if (isDateTimeRange) {
    DateRangeComponent = DateTimeRangeInput;
    if (includes(type, "with-seconds")) {
      additionalAttributes.withSeconds = true;
    }
  }

  if (isValidDateRangeValue(value) || value === null) {
    additionalAttributes.value = value;
  }

  if (hasDynamicValue) {
    additionalAttributes.placeholder = [value && value.name];
    additionalAttributes.value = null;
  }

  const onDynamicValueSelect = useCallback((dynamicValue) => {
    onSelect(dynamicValue);
  }, [onSelect]);

  return (
    <div {...rest} className={classNames("date-range-parameter", className, { "dark-mode": isDarkMode })}>
      <DateRangeComponent
        {...dateRangeOptions}
        ref={dateRangeComponentRef}
        className={classNames("redash-datepicker date-range-input", type, { "dynamic-value": hasDynamicValue })}
        onSelect={onSelect}
        suffixIcon={null}
        {...additionalAttributes}
      />
      <DynamicButton
        options={dynamicButtonOptions.options}
        staticValueLabel={dynamicButtonOptions.staticValueLabel}
        selectedDynamicValue={hasDynamicValue ? value : null}
        enabled={hasDynamicValue}
        onSelect={onDynamicValueSelect}
      />
    </div>
  );
}

DynamicDateRangePicker.propTypes = {
  type: PropTypes.string,
  value: PropTypes.any,
  onSelect: PropTypes.func,
  className: PropTypes.string,
  dynamicButtonOptions: PropTypes.object,
  dateRangeOptions: PropTypes.object,
  parameter: PropTypes.any,
};

export default DynamicDateRangePicker;
